export default function AlertYellowIcon() {
  return (
    <>
      <svg
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="72" height="72" rx="36" fill="#FFFBEB" />
        <ellipse
          cx="36.4997"
          cy="42.6667"
          rx="1.33333"
          ry="1.33333"
          transform="rotate(-180 36.4997 42.6667)"
          fill="#FFC700"
        />
        <path
          d="M36.5003 38.666L36.5003 29.3327M49.8337 35.9993C49.8337 43.3631 43.8641 49.3327 36.5003 49.3327C29.1365 49.3327 23.167 43.3631 23.167 35.9993C23.167 28.6356 29.1365 22.666 36.5003 22.666C43.8641 22.666 49.8337 28.6356 49.8337 35.9993Z"
          stroke="#FFC700"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
